var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAngleLeftSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14 16.75a.74.74 0 0 1-.53-.22l-4-4a.75.75 0 0 1 0-1.061l4-4a.75.75 0 1 1 1.061 1.061L11.061 12l3.47 3.47A.75.75 0 0 1 14 16.75"
})));
export default SvgAngleLeftSmall;